// Status Badge Component
// Displays intake status with color-coded badge

import { CheckCircle, Clock, XCircle } from 'lucide-react';

const statusConfig = {
  viable: { 
    label: 'High Priority', 
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: CheckCircle
  },
  review: { 
    label: 'Needs Review', 
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: Clock
  },
  unlikely: { 
    label: 'Lower Priority', 
    className: 'bg-slate-50 text-slate-600 border-slate-200',
    icon: XCircle
  }
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.review;
  const Icon = config.icon;
  
  return (
    <span 
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border ${config.className}`}
      data-testid="status-badge"
    >
      <Icon className="w-4 h-4" />
      {config.label}
    </span>
  );
};

export default StatusBadge;
